import { render, staticRenderFns } from "./RepresentanteLegal.vue?vue&type=template&id=b40bdfb0"
import script from "./RepresentanteLegal.vue?vue&type=script&lang=js"
export * from "./RepresentanteLegal.vue?vue&type=script&lang=js"
import style0 from "./RepresentanteLegal.vue?vue&type=style&index=0&id=b40bdfb0&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports